export const ActionTypes = {
  LOADING: "LOGIN_LOADING",
  ERROR: "LOGIN_ERROR",
  SUCCESS: "LOGIN_SUCCESS",
};
